<template>
  <modal
      @close="$emit('close')"
      class="transaction-info-modal transaction-info"
  >
    <template slot="header">
      <div
              v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate([
            'promoCode_CreatePromoCode',
            'promoCode_ChangePromoCode',
          ])"></div>
        <template v-if="type === 'create'">
          {{$t('promoCode_CreatePromoCode.localization_value.value')}}
        </template>
        <template v-else>
          {{$t('promoCode_ChangePromoCode.localization_value.value')}}
        </template>
      </div>

    </template>
    <template slot="body">
      <div class="profiles-expenses__content">

        <div class="profiles-expenses__row custom-row">
          <div class="profiles-expenses__col custom-col"
               v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
            <div class="admin-edit" @click="editTranslate(['promoCode_Code'])"></div>
            <DefaultInput
                    :label="$t('promoCode_Code.localization_value.value')"
                    v-bind:class="{'ui-no-valid': PC.validation.code}"
                    :error="PC.validation.code"
                    :errorTxt="$t(`${PC.validationTranslate.code}.localization_value.value`)"
                    :type="'text'"
                    v-model="PC.data.code"
            />
          </div>
        </div>


      </div>
    </template>
    <template slot="footer">
      <div class="d-flex justify-content-between align-center"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['common_cancel', 'common_create'])"></div>

        <span
                class="site-link site-link--alt buy-label__btn-i mr-3"
                @click="$emit('close')"
        >
          {{$t('common_cancel.localization_value.value')}}
        </span>

        <MainButton
                v-if="type === 'create'"
                :value="$t('common_create.localization_value.value')"
                class="profiles-expenses__btn-i"
                @click.native="save"
                v-bind:class="{'disabled-btn' : $store.getters.getPromoCodeBtn}"
        />
        <MainButton
                v-else
                :value="$t('common_update.localization_value.value')"
                class="profiles-expenses__btn-i"
                @click.native="save"
                v-bind:class="{'disabled-btn' : $store.getters.getPromoCodeBtn}"
        />
      </div>
    </template>
  </modal>
</template>

<script>
  import Modal from '../../../../commonModals/Modal.vue'
  import MainButton from "../../../../UI/buttons/MainButton/MainButton";
  import DefaultInput from "../../../../UI/inputs/DefaultInput/DefaultInput";
  import {PromoCode} from "@/components/globalModels/PromoCode";


  export default {
    name: "PromoCodePopup",
    components: {
      DefaultInput,
      Modal,
      MainButton,
    },


    props: {
      itemId: Number,
      type: String,
    },

    data() {
      return {
        PC: new PromoCode()
      }
    },

    mounted() {
      if(this.itemId){
        this.$store.dispatch('getPromoCode', this.itemId).then((response) => {
          this.PC.setItem(this.getRespData(response))
        }).catch(error => this.createErrorLog(error))
      }
    },

    methods: {
      save() {
        if(!this.PC.firstValidate({id: false, code: true})) return

        let saveType = 'createPromoCode'

        let data = this.PC.prepareSave()

        if (this.type === 'update') {
          saveType = 'updatePromoCode'
          data = {
            data: data,
            id: this.itemId
          }
        }

        this.$store.dispatch(saveType, data).then((response) => {

          switch (this.getResponseStatus(response)) {
            /**
             * Success
             */
            case this.$store.getters.GET_ERRORS.SUCCESS_CODE: {

              if (this.type === 'update') {
                this.openNotify('success', 'common_notificationRecordChanged')
              } else {
                this.openNotify('success', 'common_notificationRecordCreated')
              }
              this.$emit('close')
              this.$emit('reload')
              break
            }
            /**
             * Validation Error
             */
            case this.$store.getters.GET_ERRORS.VALIDATION_ERROR_CODE: {
              let errors = response.response.data.errors;
              this.notifyErrorHelper(errors)
              break
            }
            /**
             * Undefined Error
             */
            default: {
              this.openNotify('error', 'common_notificationUndefinedError')
            }
          }
        }).catch(error => this.createErrorLog(error))
      }
    }

  }

</script>

<style lang="scss" scoped>
  @media(max-width: 550px){
    .transaction-info__col{
      width: 100%;
    }

    .scoped-btns > button{
      font-size: 14px;
      padding-left: 10px;
      padding-right: 10px;
      width: fit-content;
      margin-bottom: 10px;
    }
  }
</style>
